import { render, staticRenderFns } from "./JustifyNav.vue?vue&type=template&id=37941809"
import script from "./JustifyNav.vue?vue&type=script&lang=js"
export * from "./JustifyNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports